//import Libraries
import React from 'react';
import PropTypes from 'prop-types';

//import Styles
import './MyInfo.css'

const mypageEditConfirmButton = (props) => {
    const {editing, editLabel, confirmLabel, cancleLabel, onToggle, onConfirm, onCancle, confirmDisabled} = props;
    console.log(confirmDisabled);

    return (
        <div className="Element">
            <div className="EditConfirmButton">
            {
                editing ? (
                    <div> 
                        <button
                            className="confirm"
                            onClick={() => {
                                onConfirm();
                                onToggle();
                            }}
                            disabled={confirmDisabled}
                        >
                            {confirmLabel}
                        </button>
                        <button 
                            className="cancle"
                            onClick={() => {
                                onCancle();
                                onToggle();
                            }}
                        >
                            {cancleLabel}
                        </button>
                    </div>
                ) : (
                    <div>
                        <button
                            className="edit"
                            onClick={onToggle}
                        >
                            {editLabel}
                        </button>
                    </div>
                ) 
            }
            </div>
        </div>

    );
}

export default mypageEditConfirmButton;

mypageEditConfirmButton.PropTypes = {
    confirmDisabled : PropTypes.bool
}

mypageEditConfirmButton.defaultProps = {
    confirmDisabled : false
}



// WEBPACK FOOTER //
// ./src/pages/MyPage/MyPageEditConfirmButton.js